export const progressTrackerSteps = [
  {
    id: 1,
    label: 'Soft Tag details',
  },
  {
    id: 2,
    label: 'Build formula',
  },
  {
    id: 3,
    label: 'Review and save',
  },
];

export const stepsText = [
  'General details',
  'Build formula',
  'Review soft tag before saving it',
];

export const sites = [
  { text: 'POR', value: 'POR' },
  { text: 'BLP', value: 'BLP' },
];

export const plants = [
  { text: 'NPK', value: 'NPK' },
  { text: 'Ammonia', value: 'Ammonia' },
  { text: 'Utilities', value: 'Utilities' },
];

export const units = [
  { text: 'CO2 Liquid', value: 'CO2 Liquid' },
  { text: 'Cooling Water System', value: 'Cooling Water System' },
  { text: 'NPK Prilling 4', value: 'NPK Prilling 4' },
];

export const scheduleOptions = [
  { text: 'Minutes', value: 'm' },
  { text: 'Hours', value: 'h' },
  { text: 'Days', value: 'd' },
  { text: 'Never', value: '' },
];

export const dataTypeOptions = [
  { text: 'Double', value: 'DOUBLE' },
  { text: 'Boolean', value: 'BOOLEAN' },
  { text: 'String', value: 'STRING' },
  { text: 'Integer', value: 'INTEGER' },
];

export const signalTypeOptions = [
  { text: 'Analog', value: 'ANALOG' },
  { text: 'Digital', value: 'DIGITAL' },
  { text: 'Discrete', value: 'DISCRETE' },
  { text: 'Generic', value: 'GENERIC' },
];

export const templateOptions = [
  { text: 'Timeseries COF', value: 'COF' },
  { text: 'Parsable', value: 'PARSABLE' },
];

export const cofTemplate = `''' COF Data Model

cof(
  tag_name="",
  timeseries_id="",
  limit=,
  latest=True
 )

Required fields:
tag_name (str)
timeseries_id (str)

Optional fields:
limit (int)
latest (bool, default True)

'''

# Use the following Code

retval = cof(tag_name="<tag_name>", timeseries_id="<timeseries_id>")`;

export const parsableTemplate = `''' Parsable Data Model

parsable(
  templateId="...",
  fieldId="...",
  clientId="...",
  lastExecutionTime="2025-07-16T00:00:00Z",
  latest=False
 )

Required fields:
templateId (str)
At least one of fieldId (str) or clientId (str)

Optional fields:
lastExecutionTime (str)
latest (bool, default False)

'''

# Use the following Code

retval = parsable(templateId="<template_id>", clientId="<client_id>",latest=False)`;
